import { WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number, memoTextId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/texts/${memoTextId}/`;

export const deleteFloorPlanMemoText = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  memoTextId,
}: WithBranchParams<{
  floorPlanId: number;
  memoTextId: number;
}>) => {
  const url = createApiUrl(branchUid, floorPlanId, memoTextId);
  const { data } = await axiosInstance.delete(url, {
    params: {
      version: branchVersionId,
    },
  });

  return data;
};
